import { Component } from "react";
import Card from "../../Card";
import TitleBar from "../../ui/TitleBar";

import { Link } from "react-router-dom";
import "./style.scss";

class CardDetail extends Component {

    back=()=>{
        if(this.props.onBack) this.props.onBack();
    }

    onCardUpdate=(data)=>{
        if(this.props.onCardUpdate) this.props.onCardUpdate(data);
    }

    render() {
        return (
            <div className="card-detail">
                <TitleBar title={this.props.data.category.title} />
                <Card data={this.props.data} selected={true} onCardUpdate={this.onCardUpdate} />
                <div className="action">
                    <Link to={`/${this.props.data.category.url}`} className="uh">View More Congratulations Cards</Link>
                    <div className="uh" onClick={this.back}><span className="back"></span>Back to Overview</div>
                </div>
            </div>
        )
    }
}

export default CardDetail;